<template>
	<create-edit-layout v-if="showCreateEditYearData" element="YearData" icon="fas fa-gears" @duplicatecomplete="$emit('duplicatecomplete')">
		<v-col cols="12" xs="12" sm="3">
			<ValidationProvider vid="ref_year" :name="$t('yeardata.ref_year')" rules="required" v-slot="{ errors, field }">
				<v-text-field class="required" :label="$t('yeardata.ref_year')" v-model="currentYearData.ref_year" :error-messages="errors" v-mask="'####'"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="12" xs="12" sm="3">
			<ValidationProvider vid="aliquota" :name="$t('yeardata.aliquota')" rules="required" v-slot="{ errors, field }">
				<v-text-field class="required" type="number" :label="$t('yeardata.aliquota')" :value="currentYearData.aliquota" @change="(value) => (currentYearData.aliquota = $functions.validateInputPrice(value, 'aliquota'))" :error-messages="errors" suffix="%" placeholder="00.00"></v-text-field>
			</ValidationProvider>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<date-field vid="first_deadline" :name="$t('yeardata.first_deadline')" rules="date_format" v-model="currentYearData.first_deadline"></date-field>
		</v-col>
		<v-col cols="6" xs="6" sm="3">
			<date-field vid="second_deadline" :name="$t('yeardata.second_deadline')" rules="date_format" v-model="currentYearData.second_deadline"></date-field>
		</v-col>
	</create-edit-layout>
</template>

<script>
export default {
	data: () => ({}),
	computed: {
		currentYearData: {
			get: function () {
				return this.$store.getters.getCurrentYearData;
			},
			set: function (value) {
				this.$store.commit("setCurrentYearData", value);
			},
		},
		showCreateEditYearData() {
			return this.$store.getters.showCreateEditYearData;
		},
	},
};
</script>
